import React, { createContext, useContext, useEffect } from 'react';

type Theme = 'light';

interface ThemeContextValue {
  theme: Theme;
  /** No-op — Box OS ships a single warm-cream theme. Dark mode retired (TEE-372). */
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  useEffect(() => {
    // Box OS is a single warm-cream theme. Ensure no stale `.dark` class
    // (or persisted preference) from the previous dual-theme system lingers.
    document.documentElement.classList.remove('dark');
    localStorage.removeItem('theme');
  }, []);

  const value: ThemeContextValue = { theme: 'light', toggleTheme: () => {} };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextValue => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
